<template>
  <b-container class="mt-5">
    <b-row>
      <b-col md="8" class="mx-auto">
        <b-card>
          <b-card-header class="text-center">
            <div class="d-flex justify-content-center">
              <img
                src="../../assets/g3tools-orange-64x64.png"
                width="35"
                class="mr-3"
              />
              <h2>{{ appName }}</h2>
            </div>
          </b-card-header>
          <b-card-body>
            <h5>Description</h5>
            <p>{{ description1 }}</p>
            <p>{{ description2 }}</p>

            <h5>Contact Information</h5>
            <p>
              Email:
              <a :href="'mailto:' + contactInfo.email">{{
                contactInfo.email
              }}</a>
            </p>
            <p>Phone: {{ contactInfo.phone }}</p>

            <b-list-group class="mt-4">
              <b-list-group-item>
                <strong>UI Version:</strong> {{ uiVersion }}
                <a href="/changelog" target="_blank" class="ml-2"
                  >View Changelog</a
                >
                <div class="ml-3 mt-2" v-if="user.isAppAdmin">
                  <table class="detail-info-table">
                    <tbody>
                      <tr
                        v-for="(item, index) in adminUIInfo"
                        :key="'adminUIInfo' + index"
                      >
                        <td class="key top-align">{{ item.key }}</td>
                        <td class="value top-align">{{ item.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-list-group-item>
              <b-list-group-item>
                <strong>API Version:</strong> {{ apiVersion }}
                <div class="ml-3 mt-2" v-if="user.isAppAdmin">
                  <table class="detail-info-table">
                    <tbody>
                      <tr
                        v-for="(item, index) in adminAPIInfo"
                        :key="'adminAPIInfo' + index"
                      >
                        <td class="key top-align">{{ item.key }}</td>
                        <td class="value top-align">{{ item.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-list-group-item>
              <b-list-group-item>
                <strong>Database:</strong> {{ dbName }}
                <div class="ml-3 mt-2" v-if="user.isAppAdmin">
                  <table class="detail-info-table">
                    <tbody>
                      <tr
                        v-for="(item, index) in adminDBInfo"
                        :key="'adminDBInfo' + index"
                      >
                        <td class="key top-align">{{ item.key }}</td>
                        <td class="value top-align">{{ item.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-card-body>
          <b-card-footer class="text-center">
            <small
              >© {{ new Date().getFullYear() }} {{ appName }}. All rights
              reserved.</small
            >
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AboutPage",
  data() {
    return {
      appName: "g3tools",
      description1:
        "Easy to use business tools for tracking and managing merchandise inventory between sellers and processors. g3tools also provides exception tracking, automatically linking exceptions to inventory items.",
      description2:
        "With g3tools, sellers and processors communicate more effectively, minimizing losses, and facilitating the smooth, predictable flow of sellable assets from seller source to online retailers.",
      contactInfo: {
        email: "dgarvin57@gmail.com",
        phone: "903-681-1968",
      },
      uiVersion: process.env.VUE_APP_VERSION,
      uiLatestCommit: process.env.VUE_APP_COMMIT_HASH,
      uiNodeEnvironment: process.env.VUE_APP_NODE_ENV,
      apiVersion: "2.0.1",
      apiLatestCommit: "",
      apiNodeEnvironment: "",
      apiHealthStatus: "",
      apiHealthMessage: "",
      dbName: "",
      dbVersion: "1.0.0",
      dbPort: "3300",
      dbPortProxy: "",
      dbConnectionString: "",
    };
  },
  created() {
    this.healthcheck();
    this.dbInfo();
  },
  computed: {
    ...mapGetters({
      user: "Session/user",
    }),
    adminUIInfo() {
      return [
        { key: "Latest commit: ", value: this.uiLatestCommit },
        { key: "Node environment: ", value: this.uiNodeEnvironment },
      ];
    },
    adminAPIInfo() {
      return [
        {
          key: "API status: ",
          value: `${this.apiHealthStatus}: ${this.apiHealthMessage}`,
        },
        { key: "Latest commit: ", value: this.apiLatestCommit },
        { key: "Node environment: ", value: this.apiNodeEnvironment },
      ];
    },
    adminDBInfo() {
      return [
        { key: "DB version:", value: this.dbVersion },
        { key: "DB port:", value: this.dbPort },
        { key: "DB proxy port:", value: this.dbPortProxy },
        { key: "Connect string:", value: this.dbConnectionString },
      ];
    },
  },
  methods: {
    async healthcheck() {
      const result = await this.$store.dispatch("Session/fetchHealthcheck");
      this.apiHealthStatus = `${result.status} - ${result?.data?.status}`;
      this.apiHealthMessage = result?.data?.message;
      this.apiVersion = result?.data?.version;
      this.apiLatestCommit = result?.data?.latestCommit;
      this.apiNodeEnvironment = result?.data?.nodeEnvironment;
    },
    async dbInfo() {
      const result2 = await this.$store.dispatch("Session/fetchDbInfo");
      this.dbName = result2?.data?.dbName;
      this.dbVersion = result2?.data?.dbVersion;
      this.dbPort = result2?.data?.dbPort;
      this.dbPortProxy = result2?.data?.dbPortProxy;
      this.dbConnectionString = result2?.data?.dbConnectionString;
    },
  },
};
</script>

<style scoped>
.mt-5 {
  margin-top: 3rem !important;
}
.custom-table {
  width: 100%;
  border-collapse: collapse;
}
.custom-table td {
  padding: 0.2rem;
  line-height: 1.5;
}
.detail-info-table td {
  line-height: 1.5;
  margin-left: 10px;
}
.key {
  min-width: 130px;
  text-align: left;
  font-weight: 600;
  font-size: 0.8rem;
  color: #666;
}

.value {
  text-align: left;
  overflow-wrap: break-workd;
  word-wrap: break-word;
  white-space: normal;
  font-size: 0.85rem;
}
.top-align {
  vertical-align: top;
}
</style>
